import * as Filter from '../components/filterGroup';
import { CheckIfFilingNumberExistsInEKEIDR } from "../_ekeidr";
import Modal from '../_bootstrapModalExtensions';
import Classes from '../_classes';
import * as Url from '../Utils/UrlUtil';

export function InitProcessEditTabPage() {
    Filter.Init();
}

export function EditClerkProcessStateAndCaseFileFilingNumber(processId: number, officeId: number, caseFileFilingNumber: string) {
    let modalSettings: Classes.BootstrapModalWithAjaxContentSettings = GetModalSettings();

    Modal.showBootstrapModalWithAjaxContent(modalSettings);

    function GetModalSettings(): Classes.BootstrapModalWithAjaxContentSettings {
        let settings: Classes.BootstrapModalWithAjaxContentSettings = new Classes.BootstrapModalWithAjaxContentSettings();

        const contentUrlTemplate: string = window.ETDR_RD.appConfig['UrlTemplate.GetClerkProcessStateAndCaseFileFilingNumberPartial'];
        const saveUrlTemplate: string = window.ETDR_RD.appConfig['UrlTemplate.UpdateClerkProcessStateAndCaseFileFilingNumber'];

        settings.title = 'Ügyintézési státusz és ügyirat iktatószám szerkesztése';
        settings.contentUrl = Url.createUrlFromTemplate(contentUrlTemplate, { processId: processId, officeId: officeId });
        settings.saveUrl = Url.createUrlFromTemplate(saveUrlTemplate, { processId: processId, officeId: officeId, caseFileFilingNumber: caseFileFilingNumber });
        settings.callback = (data) => callback(data);

        return settings;

        function callback(data) {
            $('#clerk-process-state').html(data.newStateName);
            $('#casefile-filing-number').html(data.caseFileFilingNumber);

            if (window.ETDR_RD.appConfig['User.CanUseEKEIDRService'] === true) {
                // After successfully update in the DB, show information to the user when the updated filing number doesn't exists in the filing system
                // This is an asynchronous call, to avoid waiting if the filing system isn't accessible
                CheckIfFilingNumberExistsInEKEIDR('#errorDiv', data.caseFileFilingNumber, true);
            }
        };
    }
}

export function SetActiveTabOnProcessEditPageLoad(s: MVCxClientPageControl, e: ASPxClientEventArgs) {
    const searchParams = new URLSearchParams(window.location.search);

    if (searchParams.has('activeTab')) {
        setActiveTab(searchParams.get('activeTab'));
    }

    function setActiveTab(activeTab: string) {
        const tabController: ASPxClientPageControl = ASPxClientControl.GetControlCollection().GetByName('processEdit');
        const tabIndex: number = tabController.GetTabByName(activeTab).index;

        s.SetActiveTabIndex(tabIndex);
    }
}

$(() => {
    $(document).on('click', '.edit-clerk-process-state-and-case-file-filing-number', (event: JQuery.TriggeredEvent) => {
        const $button: JQuery<HTMLElement> = $(event.target);
        const processId = $button.data('process-id');
        const officeId = $button.data('office-id');
        const caseFileFilingNumber = $button.data('data-caseFileFilingNumber');

        EditClerkProcessStateAndCaseFileFilingNumber(processId, officeId, caseFileFilingNumber);
    });
});
